module.exports = __webpack_public_path__ + "static/media/values_768.66dae39a.png";